var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mediaVideo"},[_c('you-tube-playlist',{ref:"vidContainer",staticClass:"videoContainer",attrs:{"videos":_vm.links,"aspect-ratio":"640:360"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }